import type {
	Application,
	Currency
} from "@nwt/norce-pwa/dist/runtime/types/api/application/application";
import type {
	ParametricListValue,
	ProductType
} from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import { defineStore } from "pinia";

interface State {
	cultureCode: string;
	currencyId: number;
	currenciesNorce: Currency[];
	currentCurrency: Currency | null;
	applicationNorce: Application | null;
	parametrics: ParametricsNorceStore;
	productTypes: ProductType[];
}

interface ParametricsNorceStore {
	[key: string]: ParametricListValue[];
}
export const useNorceStore = defineStore("norceStore", {
	state: (): State => ({
		cultureCode: "",
		currencyId: 0,
		currenciesNorce: [],
		currentCurrency: null,
		applicationNorce: null,
		parametrics: {},
		productTypes: []
	}),
	getters: {
		storeContext: (state) => ({
			cultureCode: state.cultureCode,
			currencyId: state.currencyId
		}),
		getCurrentCurrency: (state) => {
			return state.currentCurrency;
		},
		allParametrics: (state) => state.parametrics
	},
	actions: {
		setCurrencyId(newCurrencyId: number) {
			this.currencyId = newCurrencyId;
		},
		setCultureCode(newCultureCode: string) {
			this.cultureCode = newCultureCode;
		},
		initState(application: Application) {
			this.applicationNorce = application;
			this.initCurrency();
			this.setCurrenciesNorce();
		},
		setCurrenciesNorce() {
			if (this.applicationNorce) {
				if (!this.currentCurrency) {
					this.currentCurrency = this.applicationNorce?.Currencies?.Default;
				}
				this.currenciesNorce = this.applicationNorce?.Currencies?.List;
			}
		},

		updateCurrency(currencyId: number) {
			const selectedCurrency = this.currenciesNorce?.find(
				(c) => c.Id === currencyId
			);
			if (selectedCurrency) {
				this.currentCurrency = selectedCurrency;
				this.currencyId = selectedCurrency.Id;
				return selectedCurrency;
			} else {
				console.error("Currency not found");
				return null;
			}
		},
		initCurrency() {
			if (!this.currencyId && this.applicationNorce) {
				this.currencyId = this.applicationNorce?.Currencies?.Default?.Id;
			}
		},
		addAllParametrics(value: ParametricsNorceStore) {
			this.parametrics = value;
		},
		setProductTypes(value: ProductType[]) {
			this.productTypes = value;
		}
	}
});
